function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { Field } from "react-final-form";
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";
export default function RadioGroupField(param) {
    var name = param.name, label = param.label, radioButtons = param.radioButtons, isFormDisabled = param.disabled, validate = param.validate;
    return /*#__PURE__*/ _jsx(Field, {
        name: name,
        type: "radioGroup",
        validate: validate,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ _jsxs(FormControl, {
                component: "fieldset",
                error: Boolean(meta.touched && meta.error),
                disabled: isFormDisabled,
                children: [
                    /*#__PURE__*/ _jsx(FormLabel, {
                        component: "legend",
                        children: label
                    }),
                    /*#__PURE__*/ _jsx(RadioGroup, _object_spread_props(_object_spread({}, input), {
                        css: {
                            display: "inline"
                        },
                        children: radioButtons.map(function(param) {
                            var value = param.value, label = param.label, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
                            return /*#__PURE__*/ _jsx(FormControlLabel, {
                                value: value,
                                control: /*#__PURE__*/ _jsx(Radio, {}),
                                label: label,
                                disabled: disabled || isFormDisabled
                            }, value);
                        })
                    })),
                    /*#__PURE__*/ _jsx(FormHelperText, {
                        children: meta.touched && meta.error ? meta.error : ""
                    })
                ]
            });
        }
    });
}
